<!--
 * @Date: 2023-12-04 15:56:57
 * @Author: jm
 * @LastEditTime: 2024-01-02 16:34:23
 * @LastEditors: jm
 * @FilePath: \gameclub\src\components\StarCount.vue
 * @Description: 
-->
<template>
  <div class="stars">
    <span v-for="n in maxStars" :key="n" class="star">
      <img
        :src="imgUrl"
        alt=""
        class="starImg"
        v-if="n <= starCount"
        :style="{ width: starwidth + 'rem',marginRight:starRight+ 'rem',marginLeft:starleft+ 'rem'}"
      />
      <img src="" alt="" class="starImg" v-if="n > starCount" />
    </span>
  </div>
</template>

<script>

export default {
  name: "StarCount",
  props: {
    starCount: {
      type: Number,
      default: 5,
    },
    maxStars: {
      type: Number,
      default: 5,
    },
    starwidth: {
      type: Number,
      default: 0.27,
    },
    imgUrl: {
      type: String,
      default: "",
    },
    starRight:{
      type: Number,
      default: 0.2037,
    },
    starleft:{
      type: Number,
      required: false,
      default: 0,
    }
  },
};
</script>

<style lang="scss" scoped>
.stars{
  width: 55%;
  display: flex;
  justify-content: space-between;
}
.star {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.empty-star {
  color: lightgray;
}
.starImg {
  margin: 0 auto;
  text-align: center;
  width: 40px;
  margin-right: 22px;
}
</style>
